module.exports = __webpack_public_path__ + "img/2.4a0a9295.png";